import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Card,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner
} from "reactstrap";
import Header from "components/Headers/Header";
import SeasonalPreview from "components/SeasonalPreview";
import {
  getSeasonalBaseballBadges,
  getSeasonalBasketballBadges,
  getSeasonalFootballBadges
} from "store/actions/SeasonActions";

const Preview = () => {
  const dispatch = useDispatch();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 700);
  const { user } = useSelector((state) => state.auth);
  const {
    seasonLoading,
    athleteFootballBadges,
    athleteBasketballBadges,
    athletebaseballBadges
  } = useSelector((state) => state.season);
  const [currentActiveTab, setCurrentActiveTab] = useState("football");

  const TABS = [
    { id: "football", label: "FOOTBALL", data: athleteFootballBadges },
    { id: "basketball", label: "BASKETBALL", data: athleteBasketballBadges },
    { id: "baseball", label: "BASEBALL", data: athletebaseballBadges }
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (user?.athleteID) {
      [
        getSeasonalFootballBadges,
        getSeasonalBasketballBadges,
        getSeasonalBaseballBadges
      ].forEach((action) => dispatch(action(user.athleteID)));
    }
  }, [dispatch, user?.athleteID]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container>
        <Card className="p-3">
          <h1
            className="text-center my-3"
            style={{ fontSize: isSmallScreen ? "13px" : "28px" }}
          >
            My Seasonal Badges
          </h1>
          <div className="card">
            <Nav tabs>
              {TABS.map(({ id, label }) => (
                <NavItem key={id} className="px-1">
                  <NavLink
                    className={`py-2 cursor-pointer ${
                      currentActiveTab === id
                        ? "active active-tab bg-primary"
                        : "text-dark"
                    }`}
                    onClick={() => setCurrentActiveTab(id)}
                  >
                    <h2
                      className={currentActiveTab === id ? "text-white" : ""}
                      style={{ fontSize: isSmallScreen ? "13px" : "20px" }}
                    >
                      {label}
                    </h2>
                  </NavLink>
                </NavItem>
              ))}
            </Nav>

            {seasonLoading ? (
              <div className="d-flex align-items-center justify-content-center vh-100">
                <Spinner color="primary" />
              </div>
            ) : (
              <TabContent activeTab={currentActiveTab}>
                {TABS.map(({ id, data }) => (
                  <TabPane key={id} tabId={id}>
                    <Row className="d-flex justify-content-center">
                      {data?.length > 0 ? (
                        data.map((badge, index) => (
                          <Card
                            key={index}
                            className="m-3 col-xl-5 col-lg-5 col-md-8 col-sm-8 col-xs-12"
                          >
                            <SeasonalPreview data={badge} />
                          </Card>
                        ))
                      ) : (
                        <Card className="col-md-7 col-lg-6 col-sm-10 m-3 text-center py-5">
                          No Card Available
                        </Card>
                      )}
                    </Row>
                  </TabPane>
                ))}
              </TabContent>
            )}
          </div>
        </Card>
      </Container>
    </>
  );
};

export default Preview;
